import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.8.2_eslint@8.56.0_typescript@5.3.2_vite@5.0.10/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}